<template>
  <div class="bd">
    <el-backtop :bottom='100'>
      <img alt="" src="../../assets/photo/roll.png">
    </el-backtop>
    <div class="head">
      <div class="headleft">
        <img alt="" src="../../assets/photo/seven.png">
      </div>
      <div class="tabs">
        <p :class="selectIndex==1 ? 'selectp':''" class="p" @click="selectIndex=1">官网首页</p>
        <p class="vertical">|</p>
        <p :class="selectIndex==2 ? 'selectp':''" class="p" @click="selectIndex=2">产品服务</p>
        <p class="vertical">|</p>
        <p :class="selectIndex==3 ? 'selectp':''" class="p" @click="selectIndex=3">关于我们</p>
      </div>
      <div class="headright">
        <el-button type="warning" @click="register">免费试用</el-button>
        <el-button plain type="warning" @click="login">立即登录</el-button>
      </div>
    </div>
    <index-home v-show="selectIndex==1"></index-home>
    <service-mall v-show="selectIndex==2"></service-mall>
    <about-us v-show="selectIndex==3"></about-us>
    <div :style="demo" class="demo">
      <h1>现在就使用七个助手，开启降本增效之路</h1>
      <div class="headright">
        <el-button type="warning" @click="register">免费试用</el-button>
        <el-button plain type="warning" @click="login">立即登录</el-button>
      </div>
    </div>
    <div class="foot">
      <el-row>
        <el-col :span="4">
          <h1>产品</h1>
          <p>产品介绍</p>
        </el-col>
        <el-col :span="5">
          <h1>服务</h1>
          <p>解决方案</p>
          <p>公益计划</p>
          <p>帮助中心</p>
          <p>更新日志</p>
          <p>服务条款</p>
        </el-col>
        <el-col :span="5">
          <h1>公司</h1>
          <p>关于我们</p>
        </el-col>
        <el-col :span="5">
          <h1>售前咨询</h1>
          <p>400 000 0000 </p>
          <p>企业版咨询 </p>
          <p>400 000 0000 </p>
          <p>私有布署咨询 </p>

        </el-col>
        <el-col :span="5">
          <h1>联系我们</h1>
          <p>400 000 0000 </p>
          <p>使用帮助 （ 工作日：9:30 - 18:30 ）</p>
        </el-col>
      </el-row>
      <p class="bottom">
        <span>浙ICP备XXXXXXX号</span>
        <span>浙公网安备 XXXXXXXXXXX号</span>
      </p>
    </div>
  </div>
</template>
<script>
import indexHome from '@/views/index/indexHome.vue'
import aboutUs from '@/views/index/aboutUs.vue'
import serviceMall from '@/views/index/serviceMall.vue'

export default ({
  name: 'index',
  data() {
    return {
      selectIndex: 1,
      demo: {
        backgroundImage: "url(" + require('../../assets/photo/downbg.png') + ")",
      },
    }
  },
  components: {
    aboutUs,
    serviceMall,
    indexHome,
  },
  mounted() {

  },
  methods: {
    login() {
      this.$router.push({name: 'login'})
    },
    register() {
      this.$router.push({name: 'register'})
    }

  }
})
</script>

<style lang="less" scoped>
.goTop {
  height: 100vh;
  overflow-x: hidden;
}

.bd {
  display: flex;
  flex-direction: column;
}

.head {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 50px;
  background-color: white;
  height: 80px;

  .headleft {
    width: 33%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .headright {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  img {
    width: 80px;
    height: 64px;
    margin-right: 6px;
  }

  .logoh {
    font-size: 40px;
    color: #F5A540;
  }

  .tabs {
    width: 34%;
    display: flex;
    flex-direction: row;

    .vertical {
      margin: 0px 10px;
    }

    .p {
      font-size: 16px;
      color: #A0A2A5;
      cursor: pointer;
    }

    .selectp {
      color: #F5A540;
    }
  }
}

.demo {
  height: 335px;
  width: 100%;
  background-size: 100% 100%;

  h1 {
    color: rgba(245, 165, 64, 1);
    font-size: 36px;
    text-align: center;
    padding-top: 100px;
    margin-bottom: 50px;
  }

  .headright {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
}

.foot {
  height: 387px;
  line-height: 20px;
  background-color: rgba(245, 165, 64, 1);
  color: rgb(255, 255, 255);
  font-size: 14px;
  text-align: center;
  padding-top: 100px;
  padding-left: 189px;
  padding-right: 189px;

  h1 {
    color: rgba(255, 255, 255, 1);
    font-size: 18px;
    text-align: left;
    margin-bottom: 10px;
  }

  p {
    color: rgba(255, 255, 255, 1);
    font-size: 16px;
    text-align: left;
  }

  .bottom {
    margin-top: 70px;
    text-align: center;
  }
}
</style>
